import { useMemo } from 'react'
import { BaseTable } from 'Features/Projects/Table/BaseTable.view'
import {
  ServiceLevelData,
  UpdateServiceLevelPayload,
} from './ServiceLevel.types'
import { ExtendedGridColDef } from 'Features/Projects/Table/BulkUpdateModal'

interface ServiceLevelTableProps {
  data: ServiceLevelData[]
  isLoading: boolean
  updateTableData: (payload: UpdateServiceLevelPayload[]) => void
  isSaving: boolean
}

export const ServiceLevelTable = ({
  data,
  isLoading,
  updateTableData,
  isSaving,
}: ServiceLevelTableProps) => {
  const columns: ExtendedGridColDef[] = useMemo(() => {
    return [
      {
        field: 'segment',
        headerName: 'Segment',
        flex: 1,
        type: 'string',
        pinned: 'left',
      },
      // Stored as a probability (0.98 = 98 %), which safety stock reads; shown
      // and edited as a percentage. It used to be shown as a percentage but
      // edited as the raw value, so 98 typed for 98 % saved 98.
      {
        field: 'serviceLevel',
        headerName: 'Service level (%)',
        flex: 1,
        type: 'number',
        editable: true,
        valueGetter: (value: unknown) =>
          value === null || value === undefined
            ? null
            : Math.round(Number(value) * 100 * 1e6) / 1e6,
        valueSetter: (value: unknown, row: ServiceLevelData) => ({
          ...row,
          serviceLevel: Number(value) / 100,
        }),
        valueFormatter: (value: number | null) => {
          if (value === null || value === undefined) return ''
          return `${value.toFixed(1)} %`
        },
        preProcessEditCellProps: (params) => {
          const percent = Number(params.props.value)
          return { ...params.props, error: !(percent > 0 && percent < 100) }
        },
      },
    ]
  }, [])

  const handleUpdateTableData = (
    changedRows: Record<number, ServiceLevelData>
  ) => {
    // Convert BaseTable's changed rows format to our API format
    // changedRows is a Record where keys are row IDs and values are the updated row data
    const updatedData = Object.values(changedRows)
    updateTableData(updatedData)
    // Object.values(changedRows).forEach((row) => {
    //   updateTableData({
    //     segment: row.segment,
    //     serviceLevel: row.serviceLevel,
    //   })
    // })
  }

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      updateTableData={handleUpdateTableData}
      //uploadData={() => {}}
      isUploading={false}
      isSaving={isSaving}
      checkBoxSelection={true}
      pinnedColumns={['segment']}
    />
  )
}
